export const getReasonForVisit = (
  pathname: string | null | undefined,
): string => {
  if (!pathname) {
    return "";
  }
  const loweredPathname = pathname.toLowerCase();

  if (loweredPathname.includes("denture")) {
    return "dentures";
  }
  if (loweredPathname.includes("implant")) {
    return "implants";
  }
  if (loweredPathname.includes("motto")) {
    return "mottoaligners";
  }
  if (loweredPathname.includes("emergency")) {
    return "emergency";
  }
  if (
    loweredPathname.includes("broken") ||
    loweredPathname.includes("brokentooth") ||
    loweredPathname.includes("toothpain")
  ) {
    return "brokentooth-toothpain";
  }
  return "";
};
